import { ApolloError, useMutation } from '@apollo/client'

import { MUTATION_PROJECT_FILE_UNSET_ZONE } from '@libs/apollo/mutations'
import { PROJECT_FILE, ZONE } from '@libs/apollo/queries'

import { MutationProjectFileUnsetZoneArgs, ProjectFileUnsetZoneInput } from '@types'

interface Data {
  projectFileUnsetZone: boolean
}

export const useUnsetProjectFileToZone = (): {
  unsetProjectFileToZone: (input: ProjectFileUnsetZoneInput, zoneId: string) => Promise<void>
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [unsetProjectFileToZone, { loading, error, data }] = useMutation<Data, MutationProjectFileUnsetZoneArgs>(
    MUTATION_PROJECT_FILE_UNSET_ZONE,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _unsetProjectFileToZone = async (input: ProjectFileUnsetZoneInput, zoneId: string): Promise<void> => {
    try {
      await unsetProjectFileToZone({
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ZONE,
            variables: {
              id: zoneId,
            },
          },
          {
            query: PROJECT_FILE,
            variables: {
              id: input.projectFileId,
            },
          },
        ],
      })
    } catch (error) {
      console.error(error)
    }
  }

  return { unsetProjectFileToZone: _unsetProjectFileToZone, loading, error, data }
}
